/* =========================================================================
   ORÉE — booking interactions.  Vanilla JS, no dependencies.
   • AJAX add-to-cart for workshops + vouchers → Vessel's native cart.
   • Open-studio calendar (built from the weekly schedule) + reserve modal.
   • Firing request form.
   Reservations / firing requests POST to the Airtable proxy (data-endpoint);
   an empty endpoint runs in demo mode (confirms without sending).
   Idempotent; re-binds on Shopify section load.
   ========================================================================= */
(function () {
  "use strict";

  if (window.__ooreBookingLoaded) return; // the script is included by several sections — run once
  window.__ooreBookingLoaded = true;

  /* ---- one-time styles (calendar + modal + toast) ---------------------- */
  function injectCSS() {
    if (document.getElementById("oree-booking-css")) return;
    var css = `
.oree-cal__head{display:flex;justify-content:space-between;align-items:center;margin-bottom:22px}
.oree-cal__title{font-family:var(--font-display);font-weight:300;font-size:clamp(22px,2.4vw,30px);line-height:1;color:var(--ink-900);margin:0}
.oree-cal__title span{color:var(--ink-300)}
.oree-cal__nav{display:flex;gap:6px}
.oree-cal__nav button{width:40px;height:40px;border:1px solid var(--rule-hairline);background:none;cursor:pointer;color:var(--ink-900);display:inline-flex;align-items:center;justify-content:center;transition:opacity .2s var(--ease-quiet)}
.oree-cal__nav button:hover:not(:disabled){opacity:.6}
.oree-cal__nav button:disabled{color:var(--ink-300);cursor:default}
.oree-cal__dow{display:grid;grid-template-columns:repeat(7,1fr);border-top:1px solid var(--rule-soft)}
.oree-cal__dow span{padding:12px 0 10px;font:500 10px/1 var(--font-sans);letter-spacing:.14em;text-transform:uppercase;color:var(--ink-300);text-align:center}
.oree-cal__grid{display:grid;grid-template-columns:repeat(7,1fr)}
.oree-cal__cell{position:relative;aspect-ratio:1/.9;border:none;border-top:1px solid var(--rule-hairline);background:transparent;color:var(--ink-300);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;font:400 16px/1 var(--font-sans);cursor:default;font-family:var(--font-sans)}
.oree-cal__cell.is-open{color:var(--ink-900);cursor:pointer}
.oree-cal__cell.is-open:hover{background:var(--canvas-soft)}
.oree-cal__cell.is-sel{background:var(--ink-900);color:var(--paper-00)}
.oree-cal__cell.is-today .oree-cal__n{border-bottom:1px solid var(--ember-500);padding-bottom:1px}
.oree-cal__dot{width:5px;height:5px;border-radius:999px;background:var(--sage-500)}
.oree-cal__cell.is-sel .oree-cal__dot{background:var(--paper-00)}
.oree-cal__legend{margin-top:16px;display:flex;gap:22px;flex-wrap:wrap;align-items:center}
.oree-cal__legend span{display:inline-flex;align-items:center;gap:8px;font:300 12px/1 var(--font-sans);color:var(--ink-500)}
.oree-cal__legend i{width:5px;height:5px;border-radius:999px;display:inline-block}
.oree-cal__sessions{margin-top:28px;padding-top:26px;border-top:1px solid var(--rule-soft);animation:oreeFade .32s var(--ease-quiet)}
.oree-cal__srow{width:100%;display:grid;grid-template-columns:1fr auto auto;gap:18px;align-items:center;text-align:left;background:none;border:none;border-top:1px solid var(--rule-hairline);padding:15px 0;cursor:pointer;transition:padding-left .3s var(--ease-quiet);font-family:var(--font-sans)}
.oree-cal__srow:hover{padding-left:10px}
.oree-cal__srow:last-of-type{border-bottom:1px solid var(--rule-hairline)}
.oree-cal__stime{font:400 17px/1 var(--font-sans);color:var(--ink-900)}
.oree-cal__scap{font:400 12px/1 var(--font-sans);letter-spacing:.04em;color:var(--ink-500)}
.oree-cal__srsv{font:500 11px/1 var(--font-sans);letter-spacing:.12em;text-transform:uppercase;color:var(--ember-500);opacity:0;transition:opacity .2s var(--ease-quiet);white-space:nowrap}
.oree-cal__srow:hover .oree-cal__srsv{opacity:1}
.oree-bkmodal{position:fixed;inset:0;z-index:9000;background:rgba(26,24,20,.42);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;padding:24px;animation:oreeFade .32s var(--ease-quiet)}
.oree-bkmodal__panel{position:relative;background:var(--paper-00);width:100%;max-width:540px;max-height:90vh;overflow-y:auto;padding:clamp(32px,4vw,52px);box-shadow:0 40px 120px rgba(26,24,20,.22);border:1px solid var(--rule-hairline)}
.oree-bkmodal__close{position:absolute;top:18px;right:18px;background:none;border:none;cursor:pointer;color:var(--ink-500);font-size:22px;line-height:1;padding:6px}
.oree-bkmodal__panel .oree-field{display:block;margin-top:20px}
.oree-bkmodal__panel .oree-field input,.oree-bkmodal__panel .oree-field textarea{width:100%;margin-top:10px;padding:12px 0;border:none;border-bottom:1px solid var(--rule-soft);background:transparent;outline:none;font:300 18px/1.5 var(--font-sans);color:var(--ink-900);border-radius:0;resize:vertical}
.oree-toast{position:fixed;right:24px;bottom:24px;z-index:9500;background:var(--ink-900);color:var(--paper-00);padding:16px 20px;display:flex;align-items:center;gap:18px;box-shadow:0 20px 60px rgba(26,24,20,.28);animation:oreeToast .42s var(--ease-quiet);max-width:360px}
.oree-toast a{color:var(--paper-00);font:500 11px/1 var(--font-sans);letter-spacing:.12em;text-transform:uppercase;border-bottom:1px solid rgba(248,245,239,.5);white-space:nowrap}
.oree-toast span{font:300 14px/1.4 var(--font-sans)}
@keyframes oreeFade{from{opacity:0}to{opacity:1}}
@keyframes oreeToast{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
@media(max-width:520px){.oree-toast{right:16px;left:16px;bottom:16px;max-width:none}}
`;
    var s = document.createElement("style");
    s.id = "oree-booking-css";
    s.textContent = css;
    document.head.appendChild(s);
  }

  var MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var DOW = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];

  /* ---- toast ----------------------------------------------------------- */
  function toast(msg) {
    var existing = document.querySelector(".oree-toast");
    if (existing) existing.remove();
    var t = document.createElement("div");
    t.className = "oree-toast";
    t.innerHTML = '<span>' + msg + '</span><a href="/cart">View basket &rarr;</a>';
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 6000);
  }

  function updateCartCount(count) {
    var sels = ["[data-cart-count]", ".cart-count-bubble span[aria-hidden='true']", "#cart-icon-bubble .cart-count-bubble span", "#CartCount"];
    sels.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.textContent = count; });
    });
    // best-effort: tell the theme to refresh its cart UI
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
  }

  /* ---- AJAX add-to-cart (workshops + vouchers) ------------------------- */
  function bindAddForms(root) {
    (root || document).querySelectorAll("[data-oree-add-form]").forEach(function (form) {
      if (form.__ooreBound) return; form.__ooreBound = true;
      form.addEventListener("submit", function (e) {
        if (!window.fetch) return; // no fetch → let it post natively to /cart/add
        e.preventDefault();
        var btn = form.querySelector("button");
        var label = btn ? btn.innerHTML : "";
        if (btn) { btn.disabled = true; }
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [(function () {
            var item = { id: Number(form.querySelector("[name=id]").value), quantity: 1 };
            var plan = form.querySelector("[name=selling_plan]"); // subscription passes
            if (plan && plan.value) item.selling_plan = Number(plan.value);
            return item;
          })()] })
        })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || "add failed");
          return fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          var name = (cart.items[0] && cart.items[0].product_title) || "Added";
          toast("\u201C" + name + "\u201D is in your basket.");
        })
        .catch(function () { form.submit(); }) // fall back to a real navigation add
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
      });
    });
  }

  /* ---- POST a reservation / firing request ----------------------------- */
  function postBooking(endpoint, payload) {
    if (!endpoint) { // demo mode
      return new Promise(function (res) { setTimeout(res, 800); });
    }
    return fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) { if (!r.ok) throw new Error("post failed"); return r.json().catch(function(){return{};}); });
  }

  /* ---- modal ----------------------------------------------------------- */
  function openModal(buildInner) {
    var overlay = document.createElement("div");
    overlay.className = "oree-bkmodal";
    var panel = document.createElement("div");
    panel.className = "oree-bkmodal__panel";
    var close = document.createElement("button");
    close.className = "oree-bkmodal__close"; close.setAttribute("aria-label", "Close"); close.innerHTML = "&times;";
    panel.appendChild(close);
    var inner = document.createElement("div");
    panel.appendChild(inner);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = "hidden";
    function destroy() { overlay.remove(); document.documentElement.style.overflow = ""; document.removeEventListener("keydown", onKey); }
    function onKey(e) { if (e.key === "Escape") destroy(); }
    overlay.addEventListener("click", function (e) { if (e.target === overlay) destroy(); });
    close.addEventListener("click", destroy);
    document.addEventListener("keydown", onKey);
    buildInner(inner, destroy);
    return destroy;
  }

  /* ---- reserve form (open studio) -------------------------------------- */
  function reserveModal(endpoint, slot, customer) {
    customer = customer || {};
    openModal(function (inner, destroy) {
      inner.innerHTML =
        '<span class="oree-intro__label" style="margin-bottom:16px;"><span class="oree-macron"></span><span class="oree-eyebrow">Open studio</span></span>' +
        '<h3 class="oree-h2" style="margin:0;">Reserve a wheel.</h3>' +
        '<p class="oree-body" style="margin:12px 0 0;color:var(--ink-500);font-size:15px;">' + slot.label + ' \u00B7 ' + slot.time + '. Not paid here — billed by your membership, by the hour we log.</p>' +
        '<form>' +
          '<label class="oree-field"><span class="oree-eyebrow">Your name</span><input name="name" required></label>' +
          '<label class="oree-field"><span class="oree-eyebrow">Email</span><input type="email" name="email" required></label>' +
          '<label class="oree-field"><span class="oree-eyebrow">Phone</span><input type="tel" name="phone"></label>' +
          '<label class="oree-field"><span class="oree-eyebrow">Anything to tell us</span><textarea name="note" rows="2" placeholder="First time? Let us know — your introductory hour is free."></textarea></label>' +
          '<button type="submit" class="oree-btn" style="margin-top:26px;">Reserve the wheel &rarr;</button>' +
          '<span class="oree-bk-firing__status" style="display:block;margin-top:14px;"></span>' +
        '</form>';
      var form = inner.querySelector("form");
      if (customer.name) form.name.value = customer.name;
      if (customer.email) form.email.value = customer.email;
      if (customer.phone) form.phone.value = customer.phone;
      var status = inner.querySelector(".oree-bk-firing__status");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("button"); btn.disabled = true; btn.innerHTML = "Reserving\u2026";
        var data = { kind: "Open studio", type: "Open studio", date: slot.label, time: slot.time, dayKey: slot.dayKey,
          name: form.name.value, email: form.email.value, phone: form.phone.value, note: form.note.value,
          submittedAt: new Date().toISOString() };
        postBooking(endpoint, data).then(function () {
          inner.innerHTML =
            '<span class="oree-eyebrow"><span class="oree-pill__dot" style="background:var(--sage-500);margin-right:8px;"></span>Wheel reserved</span>' +
            '<h3 class="oree-h2" style="margin:16px 0 0;">Held for you — ' + slot.label + ', ' + slot.time + '.</h3>' +
            '<p class="oree-body" style="margin:16px 0 0;color:var(--ink-500);">Open studio is billed by membership, not at booking — we log your hours on the day. First time? We\u2019ll confirm a free introductory hour by email.</p>' +
            '<span class="oree-hand" style="display:block;margin-top:24px;">— see you at the Wheel</span>';
        }).catch(function () { btn.disabled = false; btn.innerHTML = "Reserve the Wheel \u2192"; status.textContent = "Something held that back. Please try once more."; });
      });
      inner.querySelector("input").focus();
    });
  }

  /* ---- calendar -------------------------------------------------------- */
  function buildCalendar(el) {
    if (el.__ooreBound) return; el.__ooreBound = true;
    var scheduleEl = el.querySelector(".oree-bk-studio__schedule");
    var schedule = {};
    try { schedule = JSON.parse(scheduleEl.textContent || "{}"); } catch (e) {}
    var endpoint = el.getAttribute("data-endpoint") || "";
    var customer = {
      name: el.getAttribute("data-customer-name") || "",
      email: el.getAttribute("data-customer-email") || "",
      phone: el.getAttribute("data-customer-phone") || ""
    };
    var monthsAhead = parseInt(el.getAttribute("data-months") || "2", 10);
    var mount = el.querySelector(".oree-bk-studio__cal-mount");

    var today = new Date(); today.setHours(0, 0, 0, 0);
    var minMonth = today.getFullYear() * 12 + today.getMonth();
    var maxMonth = minMonth + monthsAhead; // inclusive upper bound month index
    var view = { y: today.getFullYear(), m: today.getMonth() };
    var selected = null;

    function key(y, m, d) { return y + "-" + String(m + 1).padStart(2, "0") + "-" + String(d).padStart(2, "0"); }

    function render() {
      var monthIdx = view.y * 12 + view.m;
      var firstDow = (new Date(view.y, view.m, 1).getDay() + 6) % 7; // 0=Mon
      var daysInMonth = new Date(view.y, view.m + 1, 0).getDate();
      var canPrev = monthIdx > minMonth;
      var canNext = monthIdx < maxMonth;

      var html = '<div class="oree-cal__head">' +
        '<h3 class="oree-cal__title">' + MONTHS[view.m] + ' <span>' + view.y + '</span></h3>' +
        '<div class="oree-cal__nav">' +
          '<button data-prev ' + (canPrev ? "" : "disabled") + ' aria-label="Previous month">' + chevron("left") + '</button>' +
          '<button data-next ' + (canNext ? "" : "disabled") + ' aria-label="Next month">' + chevron("right") + '</button>' +
        '</div></div>';
      html += '<div class="oree-cal__dow">' + DOW.map(function (d) { return "<span>" + d + "</span>"; }).join("") + "</div>";
      html += '<div class="oree-cal__grid">';
      for (var i = 0; i < firstDow; i++) html += '<div class="oree-cal__cell" style="border-top:1px solid var(--rule-hairline);"></div>';
      for (var d = 1; d <= daysInMonth; d++) {
        var date = new Date(view.y, view.m, d);
        var dow = date.getDay();
        var open = !!schedule[String(dow)] && date >= today;
        var k = key(view.y, view.m, d);
        var isSel = selected === k;
        var isToday = date.getTime() === today.getTime();
        html += '<button class="oree-cal__cell' + (open ? " is-open" : "") + (isSel ? " is-sel" : "") + (isToday ? " is-today" : "") + '"' +
          (open ? ' data-day="' + k + '" data-dow="' + dow + '"' : " disabled") + '>' +
          '<span class="oree-cal__n">' + d + '</span>' + (open ? '<span class="oree-cal__dot"></span>' : "") + '</button>';
      }
      html += "</div>";
      html += '<div class="oree-cal__legend"><span><i style="background:var(--sage-500)"></i>open day</span><span><i style="border:1px solid var(--ink-300)"></i>closed</span></div>';
      html += '<div class="oree-cal__sessions-mount"></div>';
      mount.innerHTML = html;

      var prev = mount.querySelector("[data-prev]"), next = mount.querySelector("[data-next]");
      if (prev) prev.addEventListener("click", function () { if (canPrev) { step(-1); } });
      if (next) next.addEventListener("click", function () { if (canNext) { step(1); } });
      mount.querySelectorAll("[data-day]").forEach(function (cell) {
        cell.addEventListener("click", function () { selectDay(cell.getAttribute("data-day"), cell.getAttribute("data-dow")); });
      });
      if (selected) {
        var selCell = mount.querySelector('[data-day="' + selected + '"]');
        if (selCell) renderSessions(selected, selCell.getAttribute("data-dow"));
      }
    }

    function step(dir) { selected = null; var m = view.m + dir; view = { y: view.y + Math.floor(m / 12), m: (m % 12 + 12) % 12 }; render(); }

    function selectDay(k, dow) { selected = k; render(); }

    function renderSessions(k, dow) {
      var parts = k.split("-").map(Number);
      var dt = new Date(parts[0], parts[1] - 1, parts[2]);
      var label = DOW[(dt.getDay() + 6) % 7] + " " + parts[2] + " " + MONTHS[parts[1] - 1].slice(0, 3);
      var sessions = schedule[String(dow)] || [];
      var box = mount.querySelector(".oree-cal__sessions-mount");
      var rsvLabel = el.getAttribute("data-reserve-label") || "Reserve \u2192";
      var html = '<div class="oree-cal__sessions"><span class="oree-eyebrow">' + label + ' \u00B7 choose a session</span><div>';
      sessions.forEach(function (s, i) {
        html += '<button class="oree-cal__srow" data-time="' + s.time + '">' +
          '<span class="oree-cal__stime">' + s.time + '</span>' +
          '<span class="oree-cal__scap">up to ' + s.capacity + ' places</span>' +
          '<span class="oree-cal__srsv">' + rsvLabel + '</span></button>';
      });
      html += "</div></div>";
      box.innerHTML = html;
      box.querySelectorAll(".oree-cal__srow").forEach(function (row) {
        row.addEventListener("click", function () {
          reserveModal(endpoint, { dayKey: k, label: label, time: row.getAttribute("data-time") }, customer);
        });
      });
    }

    render();
  }

  function chevron(dir) {
    var d = dir === "left" ? "M11 4 L6 9 L11 14" : "M7 4 L12 9 L7 14";
    return '<svg width="17" height="17" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.25"><path d="' + d + '"/></svg>';
  }

  /* ---- firing form ----------------------------------------------------- */
  function bindFiring(root) {
    (root || document).querySelectorAll("[data-oree-firing]").forEach(function (form) {
      if (form.__ooreBound) return; form.__ooreBound = true;
      var endpoint = form.getAttribute("data-endpoint") || "";
      var openBtn = form.querySelector("[data-oree-firing-open]");
      var fields = form.querySelector(".oree-bk-firing__fields");
      var done = form.querySelector(".oree-bk-firing__done");
      var status = form.querySelector(".oree-bk-firing__status");
      if (openBtn) openBtn.addEventListener("click", function () {
        openBtn.parentElement.hidden = true; fields.hidden = false;
        fields.querySelector("input").focus();
      });
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = fields.querySelector("button[type=submit]"); var origLabel = btn.innerHTML; btn.disabled = true; btn.innerHTML = "Sending\u2026";
        var data = { kind: "Firing request", type: "Firing request",
          name: form.name.value, email: form.email.value, phone: form.phone.value, details: form.details.value,
          submittedAt: new Date().toISOString() };
        postBooking(endpoint, data).then(function () {
          fields.hidden = true; done.hidden = false;
        }).catch(function () { btn.disabled = false; btn.innerHTML = origLabel; if (status) status.textContent = "Something held that back. Please try once more."; });
      });
    });
  }

  /* ---- init ------------------------------------------------------------ */
  function init(root) {
    injectCSS();
    bindAddForms(root);
    bindFiring(root);
    (root || document).querySelectorAll("[data-oree-calendar]").forEach(buildCalendar);
  }

  if (document.readyState !== "loading") init(document);
  else document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();